module.exports = __webpack_public_path__ + "img/only-buildings.2ec8bcbc.svg";